import { Component, Input, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@stockaid/core';

@Component({
  selector: 'app-asc-day-until-stock-out-formula',
  templateUrl: './asc-day-until-stock-out-formula.component.html',
  styleUrls: ['./asc-day-until-stock-out-formula.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AscDayUntilStockOutFormulaComponent extends BaseComponent {
  @Input() inventory!: number;
  @Input() velocity!: number;
  @Input() daysUntilStockOut!: number;
  @Input() isWrap = false;

  constructor() {
    super();
  }
}
